<div class="out"  kzLib (click)="toogleOpts()">
  <div class="content">
    <div class="tx fs12">{{options[sel_option].text}}
      <img class="copy" src="assets/images/copy.svg"  kzLib (click)="copy($event)">
      <img class="expand" src="assets/images/exp10.svg" [ngClass]="{flip:bShowOptions}">
    </div>
  </div>
</div>
